import StyledTab from "./styled";

export default function HiddenTab(props: any) {
  return <StyledTab {...props} />;
}
